module.exports = __webpack_public_path__ + "img/des_paint_3.5edc3edc.jpg";